import TabDeclarationsComponent from './TabDeclarations/TabDeclarations'
import TabNewRequestComponent from './TabNewRequest/TabNewRequest'
import TabTasksComponent from './TabTasks/TabTasks'
import PortalAlertManagerComponent from './PortalAlertManager/PortalAlertManager'
import FiltersComponent from "./Filters/Filters";
import AdvancedNavComponent from "./AdvancedNav/AdvancedNav";
import AdvancedTabsComponent from "./AdvancedTabs/AdvancedTabs";
import TabOnboardingComponent from "./TabOnboarding/TabOnboarding";
import TabCdiFormsComponent from "./TabCdiForms/TabCdiForms";
import TabBenFinalesComponent from './TabBenFinales/TabBenFinales';
import TabProfileComponent from './TabProfile/TabProfile';

export const TabDeclarations = TabDeclarationsComponent
export const TabNewRequest = TabNewRequestComponent
export const TabTasks = TabTasksComponent
export const PortalAlertManager = PortalAlertManagerComponent
export const Filters = FiltersComponent;
export const AdvancedNav = AdvancedNavComponent;
export const AdvancedTabs = AdvancedTabsComponent;
export const TabOnboarding = TabOnboardingComponent
export const TabCdiForms = TabCdiFormsComponent
export const TabBenFinales = TabBenFinalesComponent;
export const TabProfile = TabProfileComponent;
